import styles from "../../../moveout-checklist.module.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { X } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const schema = yup.object().shape({
  livingRoomfloorCovering: yup.string(),
  livingRoomfloorCoveringOther: yup.string(),
  livingRoomWallsCeiling: yup.string(),
  livingRoomWallsCeilingOther: yup.string(),
  livingRoomWindow: yup.string(),
  livingRoomWindowOther: yup.string(),
  livingRoomWindowConvering: yup.string(),
  livingRoomWindowConveringOther: yup.string(),
  livingRoomLightingFans: yup.string(),
  livingRoomLightingFansOther: yup.string(),
  livingRoomDoorHardware: yup.string(),
  livingRoomDoorHardwareOther: yup.string(),
  livingRoomHeating: yup.string(),
  livingRoomHeatingOther: yup.string(),
  livingRoomOutletsSwitches: yup.string(),
  livingRoomOutletsSwitchesOther: yup.string(),
  livingRoomSmokeAlarm: yup.string(),
  livingRoomSmokeAlarmOther: yup.string(),
  livingRoomOther: yup.string(),
  livingRoomOtherOther: yup.string(),
});

const LivingRoomForm = ({
  onSubmitArrivalForm,
  tenantId,
  setLoading,
  moveOutCheckListInfo,
  handleChange4,
}) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const {
    control,
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const livingRoomValues = useWatch({
    control,
  });

  useEffect(() => {
    // setValue("livingRoomfloorCovering", "new");
    // setTimeout(() => {
    //   setValue("livingRoomWallsCeiling", "new");
    //   setv((p) => !p);
    // }, 2000);

    if (!moveOutCheckListInfo?.living_room_data) return;

    const data = moveOutCheckListInfo.living_room_data;

    Object.entries(data).forEach(([key, field]) => {
      if (!field || typeof field !== "object") return;

      const { value, is_other } = field;

      // Safely check that a value exists before setting
      if (is_other === 1 && value) {
        // setValue(key, "other");
        // setValue(`${key}Other`, value);
      } else if (is_other === 0 && value) {
        // setValue(key, value);
      }
      // else: don't call setValue at all
    });

    // Populate image state
    if (Array.isArray(moveOutCheckListInfo.living_room_images)) {
      // setUploadedImages(moveOutCheckListInfo.living_room_images);
    }
  }, [moveOutCheckListInfo, setValue]);

  const onSubmit = (data) => {
    const sectionName = "living_room_data";
    const formattedData = {
      livingRoomfloorCovering: {
        value:
          data.livingRoomfloorCovering === "other"
            ? data.livingRoomfloorCoveringOther
            : data.livingRoomfloorCovering,
        is_other: data.livingRoomfloorCovering === "other" ? 1 : 0,
      },
      livingRoomWallsCeiling: {
        value:
          data.livingRoomWallsCeiling === "other"
            ? data.livingRoomWallsCeilingOther
            : data.livingRoomWallsCeiling,
        is_other: data.livingRoomWallsCeiling === "other" ? 1 : 0,
      },
      livingRoomWindow: {
        value:
          data.livingRoomWindow === "other"
            ? data.livingRoomWindowOther
            : data.livingRoomWindow,
        is_other: data.livingRoomWindow === "other" ? 1 : 0,
      },
      livingRoomWindowConvering: {
        value:
          data.livingRoomWindowConvering === "other"
            ? data.livingRoomWindowConveringOther
            : data.livingRoomWindowConvering,
        is_other: data.livingRoomWindowConvering === "other" ? 1 : 0,
      },
      livingRoomLightingFans: {
        value:
          data.livingRoomLightingFans === "other"
            ? data.livingRoomLightingFansOther
            : data.livingRoomLightingFans,
        is_other: data.livingRoomLightingFans === "other" ? 1 : 0,
      },
      livingRoomDoorHardware: {
        value:
          data.livingRoomDoorHardware === "other"
            ? data.livingRoomDoorHardwareOther
            : data.livingRoomDoorHardware,
        is_other: data.livingRoomDoorHardware === "other" ? 1 : 0,
      },
      livingRoomHeating: {
        value:
          data.livingRoomHeating === "other"
            ? data.livingRoomHeatingOther
            : data.livingRoomHeating,
        is_other: data.livingRoomHeating === "other" ? 1 : 0,
      },
      livingRoomOutletsSwitches: {
        value:
          data.livingRoomOutletsSwitches === "other"
            ? data.livingRoomOutletsSwitchesOther
            : data.livingRoomOutletsSwitches,
        is_other: data.livingRoomOutletsSwitches === "other" ? 1 : 0,
      },
      livingRoomSmokeAlarm: {
        value:
          data.livingRoomSmokeAlarm === "other"
            ? data.livingRoomSmokeAlarmOther
            : data.livingRoomSmokeAlarm,
        is_other: data.livingRoomSmokeAlarm === "other" ? 1 : 0,
      },
      livingRoomOther: {
        value:
          data.livingRoomOther === "other"
            ? data.livingRoomOtherOther
            : data.livingRoomOther,
        is_other: data.livingRoomOther === "other" ? 1 : 0,
      },
    };

    const imageFiles = uploadedImages.map((img) => img.file_path);
    const imageSectionName = "living_room_images";

    onSubmitArrivalForm(
      formattedData,
      sectionName,
      imageFiles,
      imageSectionName
    );

    // handleChange4("panel2")("event", true);
  };

  const handleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(
          process.env.REACT_APP_PAYMENT_API_URL +
          `v1/move-out-report-file-upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const { file_path, file_url } = response.data.data;

        setUploadedImages((prev) => [...prev, { file_path, file_url }]);
      }
      toast.success(`Images are uploaded`);
    } catch (error) {
      console.error("Upload error:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Image upload failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const removeImage = (fileNameToRemove) => {
    setUploadedImages((prev) =>
      prev.filter((img) => img.file_path !== fileNameToRemove)
    );
  };

  return (
    <div className={`${styles.FormSec}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>1. Floor and Floor Covering</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomfloorCovering"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomfloorCovering === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomfloorCoveringOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>2. Walls and Ceiling</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomWallsCeiling"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomWallsCeiling === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomWallsCeilingOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>3. Window(s)</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomWindow"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomWindow === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomWindowOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>4. Window Covering(s)</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomWindowConvering"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomWindowConvering === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomWindowConveringOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>5. Lighting Fixture(s)/Fans</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomLightingFans"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomLightingFans === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomLightingFansOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>6. Door(s)/Hardware</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomDoorHardware"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomDoorHardware === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomDoorHardwareOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>7. Heating</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomHeating"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Heating">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomHeating === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomHeatingOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>8. Outlets/Switches</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomOutletsSwitches"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomOutletsSwitches === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomOutletsSwitchesOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>9. Smoke Alarms/CO Alarms</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="livingRoomSmokeAlarm"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {livingRoomValues?.livingRoomSmokeAlarm === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomSmokeAlarmOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>10. Other</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <Controller
                  name="livingRoomOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </FormControl>
            </div>
            {/* {livingRoomValues?.livingRoomOther === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="livingRoomOtherOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )} */}
          </div>
        </div>

        {/* <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Floor and Floor Covering
            </InputLabel>
            <Controller
              name="livingRoomfloorCovering"
              control={control}
              render={(field) => (
                <Select {...field} label="Floor and Floor Covering">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomfloorCovering === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomfloorCoveringOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Walls and Ceiling
            </InputLabel>
            <Controller
              name="livingRoomWallsCeiling"
              control={control}
              render={(field) => (
                <Select {...field} label="Walls and Ceiling">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomWallsCeiling === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomWallsCeilingOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Window(s)</InputLabel>
            <Controller
              name="livingRoomWindow"
              control={control}
              render={(field) => (
                <Select {...field} label="Window(s)">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomWindow === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomWindowOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Window Covering(s)
            </InputLabel>
            <Controller
              name="livingRoomWindowConvering"
              control={control}
              render={(field) => (
                <Select {...field} label="Window Covering(s)">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomWindowConvering === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomWindowConveringOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Lighting Fixture(s)/Fans
            </InputLabel>
            <Controller
              name="livingRoomLightingFans"
              control={control}
              render={(field) => (
                <Select {...field} label="Lighting Fixture(s)/Fans">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomLightingFans === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomLightingFansOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Door(s)/Hardware
            </InputLabel>
            <Controller
              name="livingRoomDoorHardware"
              control={control}
              render={(field) => (
                <Select {...field} label="Door(s)/Hardware">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomDoorHardware === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomDoorHardwareOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Heating</InputLabel>
            <Controller
              name="livingRoomHeating"
              control={control}
              render={(field) => (
                <Select {...field} label="Heating">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomHeating === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomHeatingOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Outlets/Switches
            </InputLabel>
            <Controller
              name="livingRoomOutletsSwitches"
              control={control}
              render={(field) => (
                <Select {...field} label="Outlets/Switches">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomOutletsSwitches === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomOutletsSwitchesOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Smoke Alarms/CO Alarms
            </InputLabel>
            <Controller
              name="livingRoomSmokeAlarm"
              control={control}
              render={(field) => (
                <Select {...field} label="Smoke Alarms/CO Alarms">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomSmokeAlarm === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomSmokeAlarmOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Other</InputLabel>
            <Controller
              name="livingRoomOther"
              control={control}
              render={(field) => (
                <Select {...field} label="Other">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {livingRoomValues?.livingRoomOther === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="livingRoomOtherOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div> */}

        <div className={`${styles.HalfSecFull}`}>
          <div className={`${styles.FileUpDuBUDiv}`}>
            <label
              htmlFor="file-upload-living-room"
              className={`${styles.UploadLabel}`}
            >
              <span>
                <div className={`${styles.UpIcon}`}>
                  <img src="/static/img/upload-floor.svg" alt="" />
                </div>
                <p>Upload Pictures</p>
                <p className={`${styles.UploadText}`}>File size upto 5 MB</p>
              </span>
            </label>
            <input
              id="file-upload-living-room"
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </div>

          <div className={`${styles.UpIMGSec}`}>
            {uploadedImages.map((img, index) => (
              <div key={index} className={`${styles.ImgFile}`}>
                <img src={img.file_url} alt={img.file_path} />
                <Button
                  type="button"
                  onClick={() => removeImage(img.file_path)}
                >
                  <X />
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button
            className={`${styles.CancelPopupBU}`}
            onClick={handleChange4("panel1")}
          >
            Cancel
          </Button>
          <Button type="submit" className={`${styles.SubmitPopupBU}`}>
            Save & Continue
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LivingRoomForm;
